import jwtDecode from "jwt-decode";
import Vue from "vue";
import Router from "vue-router";
import ContactDetailsPage from "../components/ContactDetails/ContactDetailsPage.vue";
import Error404 from "../components/Error404";
import OfflineError from "../components/OfflineError";
import AppointmentList from "../components/appointments/AppointmentList";
import CreateAppointment from "../components/appointments/CreateAppointment";
import CheckYourInbox from "../components/auth/CheckYourInbox";
import ConfirmAccount from "../components/auth/ConfirmAccount";
import ForgotPassword from "../components/auth/ForgotPassword";
import InvitationRegister from "../components/auth/InvitationRegister";
import InvitationSetPassword from "../components/auth/InvitationSetPassword";
import InvitationSuccess from "../components/auth/InvitationSuccess";
import JoinBusiness from "../components/auth/JoinBusiness";
import Login from "../components/auth/Login";
import Register from "../components/auth/Register";
import ResendCode from "../components/auth/ResendCode";
import ResetPassword from "../components/auth/ResetPassword";
import SelectBusiness from "../components/auth/SelectBusiness";
import SignIn from "../components/auth/SignIn";
import CommunicationList from "../components/communications/CommunicationList.vue";
import ContactsPage from "../components/contacts/ContactsPage.vue";
import CreateContactPage from "../components/contacts/CreateContactPage.vue";
import UpdateContactPage from "../components/contacts/UpdateContactPage.vue";
import ContractorList from "../components/contractors/ContractorList";
import ViewCustomerStatement from "../components/customers/accounts/statements/ViewCustomerStatement";
import DefaultDashboard from "../components/dashboards/DefaultDashboard.vue";
import AcceptInvite from "../components/invitations/AcceptInvite";
import InvoiceList from "../components/invoices/InvoiceList";
import ViewInvoiceOffline from "../components/invoices/ViewInvoiceOffline";
import ReceiptList from "../components/receipts/ReceiptList";
import ViewReceipt from "../components/receipts/ViewReceipt";
import PreferencesSettings from "../components/settings/PreferencesSettings";
import ProfileSettings from "../components/settings/ProfileSettings";
import SecuritySettings from "../components/settings/SecuritySettings";
import ViewVisitV2 from "../components/visit/ViewVisitV2";
import VisitList from "../components/visit/VisitList";
import VisitorList from "../components/visitors/VisitorList";
import permissionService from "../service/permission.service";

Vue.use(Router);
const router = new Router({
  mode: "history",
  routes: [
    {
      path: "/",
      name: "Index",
      component: DefaultDashboard,
      meta: {
        isMenuItem: false,
        requiredPermission: null
      }
    },
    {
      path: "/dashboard",
      name: "Dashboard",
      component: DefaultDashboard,
      meta: {
        isMenuItem: true,
        requiresAuth: true,
        requiredPermission: null,
        icon: "meteor",
        position: -1
      }
    },
    {
      path: "/statement",
      name: "CustomerStatement",
      component: ViewCustomerStatement,
      meta: {
        isMenuItem: true,
        requiresAuth: true,
        requiredPermission: "CUSTOMER_READ",
        icon: "file-alt",
        position: 3
      }
    },
    {
      path: "/sign-in",
      name: "sign-in",
      component: SignIn,
      meta: {
        isMenuItem: false
      }
    },
    {
      path: "/login",
      name: "login",
      component: Login,
      meta: {
        isMenuItem: false
      }
    },
    {
      path: "/select-business",
      name: "select-business",
      component: SelectBusiness,
      meta: {
        isMenuItem: false
      }
    },
    {
      path: "/register",
      name: "register",
      component: Register,
      meta: {
        isMenuItem: false
      }
    },
    {
      path: "/join-business",
      name: "join-business",
      component: JoinBusiness,
      meta: {
        isMenuItem: false
      }
    },
    {
      path: "/invitation/register",
      name: "invitation-register",
      component: InvitationRegister,
      meta: {
        isMenuItem: false
      }
    },
    {
      path: "/invitation/set-password",
      name: "invitation-set-password",
      component: InvitationSetPassword,
      meta: {
        isMenuItem: false
      }
    },
    {
      path: "/invitation/success",
      name: "invitation-success",
      component: InvitationSuccess,
      meta: {
        isMenuItem: false
      }
    },
    {
      path: "/forgot-password",
      name: "forgot-password",
      component: ForgotPassword,
      meta: {
        isMenuItem: false
      }
    },
    {
      path: "/reset-password",
      name: "reset-password",
      component: ResetPassword,
      meta: {
        isMenuItem: false
      }
    },
    {
      path: "/check-inbox",
      name: "check-inbox",
      component: CheckYourInbox,
      meta: {
        isMenuItem: false
      }
    },
    {
      path: "/contractors",
      name: "Contractors",
      component: ContractorList,
      meta: {
        isMenuItem: true,
        requiredPermission: "CONTRACTORS_READ",
        icon: "user",
        position: 4,
        permissions: ["ROLES_READ"]
      }
    },
    {
      path: "/contacts",
      name: "ContactsPage",
      component: ContactsPage,
      meta: {
        isMenuItem: true,
        requiredPermission: "OWNERS_READ",
        icon: "user",
        position: 4,
        permissions: ["ROLES_READ"]
      }
    },
    {
      path: "/invitations/:id/accept",
      name: "accept-invitation",
      component: AcceptInvite,
      meta: {
        isMenuItem: false
      }
    },
    {
      path: "/customers/:customerId/accounts/:accountId/statement",
      name: "ViewAccountStatement",
      component: ViewCustomerStatement,
      meta: {
        isMenuItem: true,
        requiredPermission: "CUSTOMER_STATEMENT_READ",
        permissions: ["VIEW_CUSTOMER_GROUPS"]
      }
    },
    {
      path: "/receipts/:id",
      name: "view-receipt",
      component: ViewReceipt,
      meta: {
        isMenuItem: false,
        requiredPermission: "RECEIPT_READ",
        permissions: ["ROLES_READ"]
      }
    },
    {
      path: "/receipts",
      name: "Receipts",
      component: ReceiptList,
      meta: {
        isMenuItem: true,
        requiredPermission: "RECEIPTS_READ",
        icon: "user",
        position: 4,
        permissions: ["ROLES_READ"]
      }
    },
    {
      path: "/appointments/create",
      name: "CreateAppointment",
      component: CreateAppointment,
      meta: {
        isMenuItem: true,
        requiredPermission: "APPOINTMENT_CREATE",
        icon: "user",
        position: 4,
        permissions: ["ROLES_READ"]
      }
    },
    {
      path: "/appointments",
      name: "Appointments",
      component: AppointmentList,
      meta: {
        isMenuItem: true,
        requiredPermission: "APPOINTMENTS_READ",
        icon: "user",
        position: 4,
        permissions: ["ROLES_READ"]
      }
    },
    {
      path: "/visits",
      name: "Visits",
      component: VisitList,
      meta: {
        isMenuItem: true,
        requiredPermission: "VISITS_READ",
        icon: "user",
        position: 4,
        permissions: ["ROLES_READ"]
      }
    },
    {
      path: "/visits/:id",
      name: "view-visit",
      component: ViewVisitV2,
      meta: {
        isMenuItem: false,
        requiredPermission: "VISITS_READ",
        permissions: ["ROLES_READ"]
      }
    },
    {
      path: "/visitors",
      name: "VisitorsList",
      component: VisitorList,
      meta: {
        isMenuItem: true,
        requiredPermission: "VISITORS_READ",
        icon: "user",
        position: 4,
        permissions: ["ROLES_READ"]
      }
    },
    {
      path: "/communications",
      name: "Communications",
      component: CommunicationList,
      meta: {
        isMenuItem: false,
        requiredPermission: "REPORT_SALES_BY_DAY_READ",
        permissions: ["USERS_READ"]
      }
    },
    {
      path: "/invoices",
      name: "Invoices",
      component: InvoiceList,
      meta: {
        isMenuItem: true,
        requiredPermission: "INVOICES_READ",
        icon: "book",
        position: 2,
        permissions: ["INVOICES_READ"]
      }
    },

    {
      path: "/invoices/:id",
      name: "view-invoice",
      component: ViewInvoiceOffline,
      meta: {
        isMenuItem: false,
        requiredPermission: "INVOICE_READ",
        permissions: ["INVOICES_READ"]
      }
    },
    {
      path: "/settings/profile",
      name: "profile-settings",
      component: ProfileSettings,
      meta: {
        isMenuItem: false,
        requiredPermission: null,
        permissions: []
      }
    },
    {
      path: "/settings/security",
      name: "security-settings",
      component: SecuritySettings,
      meta: {
        isMenuItem: false,
        requiredPermission: null,
        permissions: []
      }
    },
    {
      path: "/settings/preferences",
      name: "preferences-settings",
      component: PreferencesSettings,
      meta: {
        isMenuItem: false,
        requiredPermission: null,
        permissions: []
      }
    },
    {
      path: "/register/confirm",
      name: "Confirm Account",
      component: ConfirmAccount,
      meta: {
        isMenuItem: true,
        requiredPermission: "",
        permissions: ["VIEW_CUSTOMER_GROUPS"]
      }
    },
    {
      path: "/register/resend-code",
      name: "Resend Code",
      component: ResendCode,
      meta: {
        isMenuItem: true,
        requiredPermission: "",
        permissions: ["VIEW_CUSTOMER_GROUPS"]
      }
    },
    {
      path: "/offline",
      name: "OfflineError",
      component: OfflineError,
      meta: {
        isMenuItem: false,
        requiredPermission: "",
        permissions: ["VIEW_STORE"]
      }
    },
    {
      path: "/contacts/create",
      name: "create-contact",
      component: CreateContactPage,
      meta: {
        isMenuItem: false,
        requiredPermission: "CUSTOMER_CREATE",
        permissions: ["ROLES_READ"]
      }
    },
    {
      path: "/contacts/:id/edit",
      name: "update-contact",
      component: UpdateContactPage,
      meta: {
        isMenuItem: false,
        requiredPermission: "CUSTOMER_UPDATE",
        permissions: ["CUSTOMER_UPDATE"]
      }
    },
    {
      path: "/contacts/:id/basic-details",
      name: "view-contact-basic-details",
      component: ContactDetailsPage,
      meta: {
        isMenuItem: false,
        requiredPermission: "OWNER_READ",
        permissions: ["ROLES_READ"]
      }
    },
    {
      path: "/contacts/:id",
      name: "view-contact-details",
      component: ContactDetailsPage,
      meta: {
        isMenuItem: false,
        requiredPermission: "OWNER_READ",
        permissions: ["ROLES_READ"]
      }
    },
    {
      path: "*",
      name: "Any",
      component: Error404,
      meta: {
        isMenuItem: true,
        requiredPermission: "ACCESS_DENIED",
        permissions: ["DASHBOARD_READ"]
      }
    }
  ],
  linkActiveClass: "active"
});

router.beforeEach(async (to, from, next) => {
  const requiredPermission = to.meta.requiredPermission;

  const publicPages = [
    "/login",
    "/register",
    "/register/resend-code",
    "/register/activate",
    "/register/confirm"
  ];
  const authRequired = !publicPages.includes(to.path);

  if (authRequired && requiredPermission) {
    let user = JSON.parse(localStorage.getItem("user"));
    if (!user) {
      await router.push("/login");
    }

    let decoded = jwtDecode(user.token);
    let userId = decoded.sub;

    if (userId && !localStorage.getItem("mid")) {
      await router.push("/select-business");
      return;
    }

    // Skip permission check for customer contacts
    const selectedContext = localStorage.getItem("selectedContext");
    if (selectedContext) {
      try {
        const context = JSON.parse(selectedContext);
        if (context.actorType === "CUSTOMER_CONTACT") {
          // Customer contacts bypass permission checks
          next();
          return;
        }
      } catch (e) {
        console.error("Error parsing selected context:", e);
      }
    }

    let data = {
      storeId: localStorage.getItem("mid"),
      userId: userId,
      permissions: [requiredPermission]
    };
    permissionService
      .check(data)
      .then(response => {
        let success = response.data.success;
        if (success) {
          const hasPermission = response.data.data[requiredPermission];
          if (!hasPermission) {
            Swal.fire({
              icon: "error",
              title: "Access Denied",
              text: `You do not have permission to access this page.`,
              footer: '<a href="">Why do I have this issue?</a>'
            }).then(() => {
              // Redirect the user back to the previous route after closing the SweetAlert
              // Cancel the current navigation
              next(false);
              // Explicitly push to the previous route
              router.push(from.fullPath);
            });
          } else {
            next();
          }
        } else {
          this.fireNotification("error", response.data.narrative, 5000);
        }
      })
      .catch(e => {
        if (
          e.response.status === 401 ||
          e.response.status === 403 ||
          e.response.status === 409
        ) {
          return;
        }
        this.fireNotification("error", "Error occurred", 5000);
      });
  } else {
    next();
  }
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js